import createIcon from '../../createIcon';

/**
 * @component @name FormatAlignJustify
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAyMUgyMVYxOUgzVjIxWk0zIDE3SDIxVjE1SDNWMTdaTTMgMTNIMjFWMTFIM1YxM1pNMyA5SDIxVjdIM1Y5Wk0zIDNWNUgyMVYzSDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatAlignJustify = createIcon('FormatAlignJustify', [
  [
    'path',
    {
      d: 'M3 21H21V19H3V21ZM3 17H21V15H3V17ZM3 13H21V11H3V13ZM3 9H21V7H3V9ZM3 3V5H21V3H3Z',
      key: '8cjq1q',
    },
  ],
]);

export default FormatAlignJustify;
